import { Grid, Link, Stack, Typography } from 'ui';

export const ErrorPage = ({
  href,
  backHomeLabel,
  message,
  title,
}: {
  href?: string;
  backHomeLabel?: string;
  message?: string;
  title?: string;
}) => {
  const resolvedTitle = title ?? 'Error';
  const resolvedMessage = message ?? 'Something went wrong!';
  const resolvedBackHomeLabel = backHomeLabel ?? 'Back Home';

  return (
    <Grid sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center', mt: 20 }}>
      <Grid container sx={{ alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
        <Typography variant="h1">{resolvedTitle}</Typography>
        <Stack direction="row" spacing={2}>
          <Typography>{resolvedMessage}</Typography>
        </Stack>
        {href ? <Link href={href}>{resolvedBackHomeLabel}</Link> : null}
      </Grid>
    </Grid>
  );
};
